// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EPNf8","comment":"styles_comment__2NQHX"};